import React from 'react';
import { jsx, ClassNames } from '@emotion/react';

/**
 * This wrapper allows us to also render non-IFL icons.
 */
const IconWrapper = _ref => {
  let {
    children,
    className,
    sx,
    ...props
  } = _ref;
  return jsx(ClassNames, null, _ref2 => {
    let {
      cx
    } = _ref2;
    return /*#__PURE__*/React.cloneElement(children, {
      "aria-hidden": children.props["aria-hidden"] ?? true,
      className: cx(className, children.props.className),
      sx: {
        display: "block",
        flex: "0 0 auto",
        ...sx,
        ...children.props.sx
      },
      ...props
    });
  });
};
IconWrapper.displayName = "IconWrapper";

export { IconWrapper };
